<script setup lang="ts">
import MapControlPanel from '@/components/_common/navbar/MapControlPanel.vue';
import ThreeColumnLayout from "@/components/_common/ThreeColumnLayout.vue";
import CommonSearch from '@/components/_common/CommonSearch.vue';
import GeofencesTabs from "@/components/geofence/list/GeofencesTabs.vue";
import BleAnchorMap from '@/components/geofence/map/BleAnchorMap.vue';
import BleAnchorList from '@/components/geofence/list/BleAnchorList.vue';
import SliderSearchTabsBar from '@/components/_common/SliderSearchTabsBar.vue';

const typeId = 'anchorsTabs';

import {useSynchronizedUrlQuerySearchStore} from "@/composables/useSynchronizedUrlQuerySearchStore";
useSynchronizedUrlQuerySearchStore();

import { useSynchronizedSidebars } from "@/composables/useSynchronizedSidebars";
useSynchronizedSidebars({ defaultOpenSidebar: 'right', persistScoutOpenState: true });

import {useSynchronizedSearchBleList} from "@/composables/useSynchronizedSearchBleList";
useSynchronizedSearchBleList()

import {useSynchronizedSearchSlideBar} from "@/composables/useSynchronizedSearchSlideBar";
useSynchronizedSearchSlideBar(typeId);

import {useResetChatOnSidebarClose} from "@/composables/useResetChatOnSidebarClose";
useResetChatOnSidebarClose();

import {useResetChatOnAccountOrUserChange} from "@/composables/useResetChatOnAccountOrUserChange";
useResetChatOnAccountOrUserChange();

import * as events from '@/events';
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {setTitle} from "@/utils/title";
const store = useStore();


setTitle('Anchors');
onMounted(() => {
  const accountId = store.getters['auth/accountId'];
  store.dispatch('bleAnchor/fetchByAccountId', { accountId });
  events.trigger(events.names.GEOFENCE_LIST_VIEWED);
});

const bleAnchors = computed(() => store.getters['bleAnchor/filtered']);
</script>


<template>
  <ThreeColumnLayout>
    <template #leftTop>
      <SliderSearchTabsBar  v-if="$can('view', 'Anchors')" :typeId="typeId" placeholder="Search Anchors..." >
        <template #tabs>
          <GeofencesTabs />
        </template>
      </SliderSearchTabsBar>
      <CommonSearch
        v-else
        placeholder="Search Anchors..."
      />
    </template>
    <template #left>
      <BleAnchorList class="h-full" :bleAnchors="bleAnchors" />
    </template>
    <template #rightTop>
      <MapControlPanel>
        <template #filters>
        </template>
      </MapControlPanel>
    </template>
    <template #right>
      <BleAnchorMap view="cluster" />
    </template>
  </ThreeColumnLayout>
</template>
